import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CardValidity } from '@signature-it/ngx-generic/models';


export class FormValidatorsService {

    static isValidIsraeliID(control: UntypedFormControl) {
        let id = String(control.value).trim();
        if(!id) return null;
        if (id.length != 9) {
            return { customValid: true };
        }

        let valid =  Array.from(id, Number).reduce((counter, digit, i) => {
            const step = digit * ((i % 2) + 1);
            return counter + (step > 9 ? step - 9 : step);
        }) % 10 === 0;

        if (!valid) {
            return{ customValid: true };
        }
        return null;
    }

    static isValidCreditCardNumber(control: UntypedFormControl) {
        const val = control.value;
        if (!val) return null;
        const len = String(val).trim().length;
        if (isNaN(val) || (len < 8) || (len > 16)) {
            return { customValid: true };
        }
        return null;
    }

    static isValidCardCvv(control: UntypedFormControl) {
        /* Validation functionality is according to CreditGuard front validation - https://cgmpi.creditguard.co.il/CGMPI_Server/merchantPages/ResponsiveWebSources/js/main.js */
        const val = control.value;
        if (!val) return null;
        const len = String(val).trim().length;
        if (((isNaN(val)) || (len < 3) || (len > 4)) && (val != "0" && val != "2" && val != "9")) {
            return { customValid: true };
        }
        return null;
    }

    static isValidExpDate(control: UntypedFormGroup) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const selectedMonth = control.get(CardValidity.MONTH_FIELD).value;
        const selectedYear = control.get(CardValidity.YEAR_FIELD).value;
        if (year === selectedYear) {
            if (selectedMonth < month) {
                return { customValid: true };
            }
        }
        return null;
    }

}
